export const style = {
  linearProgressColor: {
    sx: (color: string) => {
      return {
        '& .MuiLinearProgress-bar': {
          background: `${color}`,
        },
      };
    },
  },
  boxContainer: {
    sx: {
      '& .MuiLinearProgress-root': {
        borderRadius: 14,
      },
    },
  },
  progressbar: {
    sx: {
      width: '100%',
      height: 16,
    },
  },
} as const;
